<template>
	<div>
		<div class="sidebar-wrapper" :class="{ opened: opened }">
			<router-link tag="a" to="/profile" class="head bg-primary " v-ripple>
				<div class="avatar" v-if="loggedUser.avatar" :style="{ backgroundImage: `url('${loggedUser.avatar.urlThumb}')` }">
					<div class="pts" :class="loggedUser.top == 15 ? 'bg-success' : loggedUser.top == 70 ? 'bg-warning' : 'bg-danger'">{{ loggedUser.points }}</div>
				</div>
				<div class="avatar" v-else :style="{ backgroundImage: `url('${require('@/assets/img/user-avatar.png')}')` }">
					<div class="pts" :class="loggedUser.top == 15 ? 'bg-success' : loggedUser.top == 70 ? 'bg-warning' : 'bg-danger'">{{ loggedUser.points }}</div>
				</div>
				<div class="data">
					<div>
						<div class="username">{{ loggedUser.name }} {{ loggedUser.lastname }}</div>
						<!-- <p>{{ loggedUser.email }}</p> -->
						<p>{{ loggedUser.business }}</p>
					</div>
					<div>
						<i class="icon icon-chevron-right invert icon-xs"></i>
					</div>
				</div>
			</router-link>

			<!-- <h3>Generales</h3> -->
			<div class="list-group list-group-flush mt-2 flex-grow-1">
				<div class="list-group-item list-group-item-action " v-ripple @click="$refs.sellForm.open()">
					<i class="icon icon-social-usd"></i>
					<span>Registrar venta</span>
				</div>

				<router-link to="/sells-history" class="list-group-item list-group-item-action " v-ripple>
					<i class="icon icon-back-in-time"></i>
					<span>Historial de ventas</span>
				</router-link>

				<router-link to="/conditions" class="list-group-item list-group-item-action " v-ripple>
					<i class="icon icon-clipboard"></i>
					<span>Bases y condiciones</span>
				</router-link>

				<!-- <router-link to="/" class="list-group-item list-group-item-action " v-ripple>
					<i class="icon icon-list-bullet"></i>
					<span>Tareas pendientes</span>
				</router-link>

				<router-link to="/payment/booking" class="list-group-item list-group-item-action " v-ripple>
					<i class="icon icon-social-usd"></i>
					<span>Cobrar</span>
				</router-link> -->

				<div class="list-group-item list-group-item-action " v-ripple v-if="$installer.canInstall" @click="$installer.prompt">
					<i class="icon icon-mobile"></i>
					<span>Instalar en dispositivo</span>
				</div>
			</div>

			<div class="list-group list-group-flush mt-2 ">
				<router-link to="/logout" class="list-group-item list-group-item-action " v-ripple>
					<i class="icon icon-logout"></i>
					<span>Salir</span>
				</router-link>
			</div>
		</div>

		<div class="backdrop" :class="{ opened: opened }" @click="$emit('closed')"></div>

		<SellFormModal ref="sellForm" @created="sellCreated" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import SellFormModal from '@/views/SellFormModal'

export default {
	name: 'Sidebar',
	props: {
		opened: {
			default: false,
		},
	},
	components: {
		SellFormModal,
	},
	data() {
		return {
			showUserNotification: false,
			unreadCounter: 0,
			appVersion: process.env.VUE_APP_VERSION,
		}
	},
	computed: {
		...mapGetters(['loggedUser']),
	},
	methods: {
		sellCreated() {
			this.$router.push('/')
		},
	},
}
</script>

<style scoped>
.sidebar-wrapper {
	width: 320px;
	height: 100%;
	overflow: hidden;
	top: 0px;
	z-index: 100;
	position: fixed;
	color: #000000;
	background-color: #fff;
	transition: all 0.3s ease-in-out;

	display: flex;
	flex-direction: column;

	height: 100%;
	left: -330px;
	-webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	-moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
	box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
}

.sidebar-wrapper.opened {
	left: 0px !important;
}

.sidebar-wrapper .head {
	font-weight: normal;
	padding: 24px 16px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	color: #fff;
	/* background-color: #a50034; */
}
.sidebar-wrapper .head:hover {
	background-color: #a50034 !important;
}

.sidebar-wrapper .head .data {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-top: 16px;
}
.sidebar-wrapper .head .data .icon {
	width: 20px;
	height: 20px;
}

.sidebar-wrapper .head .avatar {
	width: 64px;
	height: 64px;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	position: relative;
	border: 3px solid #fff;
}
.sidebar-wrapper .head .avatar .pts {
	width: 28px;
	height: 28px;
	background-color: #f2f2f2;
	border: 1px solid #fff;
	border-radius: 50%;
	position: absolute;
	right: -12px;
	font-size: 10px;
	font-weight: 600;
	bottom: -4px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sidebar-wrapper .head .username {
	font-size: 1.1rem;
	line-height: 14px;
}
.sidebar-wrapper .head p {
	margin: 0px;
	color: #ffffff90;
}

.sidebar-wrapper .list-group {
	width: 100%;
	overflow: auto;
	max-height: calc(100% - 112px);
	display: block;
	background-color: inherit;
}
.sidebar-wrapper .list-group .list-group-item {
	background-color: transparent;
	color: inherit;
	padding: 0px;
	height: 44px;
	border: none;
	font-weight: 600;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #333;
}
.sidebar-wrapper .list-group .list-group-item:hover {
	background-color: #00000010;
}
.sidebar-wrapper .list-group .list-group-item .icon {
	width: 54px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.sidebar-wrapper .list-group .list-group-item .icon i {
	color: inherit;
	font-size: 18px;
}
.sidebar-wrapper .list-group .list-group-item span {
	font-size: 13px;
	flex-grow: 1;
}
.sidebar-wrapper .list-group .list-group-item .expand {
	width: 54px;
	text-align: center;
	display: inline-block;
}
.sidebar-wrapper:hover .list-group .list-group-item span {
	opacity: 1;
}

.list-group-item.expandible:not(.collapsed) {
	background-color: #a50034 !important;
}
.sidebar-wrapper .list-group .list-group-item-child {
	padding-left: 54px;
	height: 34px;
	line-height: 34px;
	background-color: #a50034;
}
.sidebar-wrapper .list-group .list-group-item-child:hover {
	background-color: #a50034;
}
.sidebar-wrapper .list-group .list-group-item-child.selected {
	background-color: #a50034;
}

.sidebar-wrapper h3 {
	font-size: 12px;
	text-transform: uppercase;
	padding: 20px 0px 0px 12px;
	margin: 0px;
	opacity: 0.5;
}

.list-group-item.collapsed .expand.when-open,
.list-group-item:not(.collapsed) .expand.when-closed {
	display: none;
}

.sidebar-wrapper .dropdown {
	width: 100%;
}
.sidebar-wrapper .btn.dropdown-toggle {
	height: 58px;
	background-color: #a50034;
	color: #fff;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}

.sidebar-wrapper .dropdown .btn:hover {
	background-color: #a50034;
}

.navbar .user-dropdown .btn.dropdown-toggle {
	/* height:58px; */
	background-color: #fff;
	color: #000;
	display: flex;
	align-items: center;
	border: none;
	border-radius: 0px;
	font-size: 12px;
}
.navbar .user-dropdown .btn.dropdown-toggle .avatar {
	width: 32px;
	height: 32px;
	border: 1px solid #d8d8d8;
	background-color: #f2f2f2;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	border-radius: 50%;
	margin-right: 8px;
}
.navbar .user-dropdown .btn.dropdown-toggle .username {
	line-height: 14px;
	text-align: left;
	padding-right: 4px;
}

.icons-reminders {
	padding: 0px 16px;
	display: inline-flex;
	align-items: center;
}

.btn-header {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 32px;
	text-align: center;
	color: #78858a;
	border: 1px solid #d3d9db;
	border-radius: 100%;
	position: relative;
	margin: 0px 14px 0px 8px;
}
.btn-header .icon {
	font-size: 16px;
}
.btn-header .badge {
	border: solid 2px #fff;
	position: absolute;
	top: -6px;
	right: -10px;
	width: 20px;
	height: 20px;
	display: block;
	justify-content: center;
	align-items: center;
	padding: 0px;
	font-size: 10px;
	line-height: 17px;
	font-weight: 500;
}

.backdrop {
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #00000025;
	z-index: -1;
	display: none;
}
.backdrop.opened {
	z-index: 10 !important;
	display: block;
}
</style>
